import React from 'react';
import { observer } from 'mobx-react';
import { ConnectionTypeField } from '../common-fields/connection-type.field';
import { PanelistLinkConnectionField as FieldKey, FORM_CONFIG } from './panelist-link-connection.form-config';
import { PanelistLinkConnectionFormVm } from './panelsit-llink-connection.form-vm';
import { FormFieldInput } from '../../../../../../../global/form/form-field-input/form-field-input';
import { ConnectionVersion } from '../../../../../../../../constants/common.constants';

export const PanelistLinkConnectionFormBody = observer((props: {
    vm: PanelistLinkConnectionFormVm;
}): JSX.Element => {
    const { vm } = props;

    const {
        label,
        connectionId,
        connectionLink,
        connectionPassword,
        participantId,
        connectionAccount,
        attendeeEmail,
        connectionVersion,
        attendeeId,
    } = vm.getFormFields(FieldKey);

    const isMeetingV2 = connectionVersion.value as string === ConnectionVersion.V2;

    return (
        <form className='oe-form'>
            <div className='oe-form__body'>
                    <ConnectionTypeField value={vm.type} />

                    {
                        isMeetingV2 &&
                        <FormFieldInput.Text
                            field={attendeeId}
                            labelDescriptor={FORM_CONFIG[FieldKey.ATTENDEE_ID].labelDescriptor}
                            disabled={true}
                        />
                    }

                    <FormFieldInput.Text
                        field={label}
                        labelDescriptor={FORM_CONFIG[FieldKey.LABEL].labelDescriptor}
                        withError
                        withCopyBtn
                    />

                    <FormFieldInput.Text
                        field={connectionId}
                        labelDescriptor={FORM_CONFIG[FieldKey.WEBINAR_ID].labelDescriptor}
                        withError
                        withCopyBtn
                        disabled={true}
                    />

                    <FormFieldInput.Text
                        field={attendeeEmail}
                        labelDescriptor={FORM_CONFIG[FieldKey.ATTENDEE_EMAIL].labelDescriptor}
                        withError
                        withCopyBtn
                    />

                    <FormFieldInput.Text
                        field={connectionLink}
                        labelDescriptor={FORM_CONFIG[FieldKey.CONNECTION_LINK].labelDescriptor}
                        withError
                        withCopyBtn
                    />

                    <FormFieldInput.Text
                        field={connectionPassword}
                        labelDescriptor={FORM_CONFIG[FieldKey.CONNECTION_PASSWORD].labelDescriptor}
                        withError
                        withCopyBtn
                    />

                    <FormFieldInput.Text
                        field={connectionAccount}
                        labelDescriptor={FORM_CONFIG[FieldKey.CONNECTION_ACCOUNT].labelDescriptor}
                        withError
                        withCopyBtn
                    />

                    <FormFieldInput.Text
                        field={participantId}
                        labelDescriptor={FORM_CONFIG[FieldKey.PARTICIPANT_ID].labelDescriptor}
                        withError
                        withCopyBtn
                    />
                </div>
        </form>
    );
});